module.exports = __webpack_public_path__ + "assets/3439b887d999b8225b98a744baff2017.mp3";